import { render } from "./AwsSearchDiscount.vue?vue&type=template&id=bff5f7c8&scoped=true"
import script from "./AwsSearchDiscount.vue?vue&type=script&lang=js"
export * from "./AwsSearchDiscount.vue?vue&type=script&lang=js"

import "./AwsSearchDiscount.vue?vue&type=style&index=0&id=bff5f7c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff5f7c8"]])

export default __exports__